<template>
  <div>
    <table class="table" :class="tableClass">
      <thead>
        <slot name="columns">
          <th v-for="column in columns" :key="column">{{ column }}</th>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td>
            <span>{{ item.binBarcodes }}</span>
          </td>
          <td>
            <span>{{ item.reference_id }}</span>
          </td>
          <td>
            <span>{{ item.total_quantity }}</span>
          </td>
          <td>
            <span>{{ item.bins }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <b-modal ref="my-modal" hide-footer title="How Many Reprints?">
      <div class="d-block text-center">
        <!-- <h5>Quantity</h5> -->
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-12">
              <fg-input type="number" label="Quantity:" v-model="quantity">
              </fg-input>
            </div>
          </div>

          <div class="row"></div>

          <div class="row"></div>

          <div class="row"></div>
          <div class="clearfix"></div>
          <br />
          <div class="text-center">
            <p-button
              type="info"
              round
              @click.native.prevent="Undo"
            >
              Undo
            </p-button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import QuantityModal from "@/components/QuantityModal.vue";
export default {
  name: "empty-table",
  data() {
    return {
      isModalVisible: false,
      quantity: "",
    };
  },
  components: {
    QuantityModal,
  },
  props: {
    columns: Array,
    data: Array,
    type: {
      type: String, // striped | hover
      default: "striped",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },
  },
  methods: {
    showModal(item) {
      console.log("item: " + JSON.stringify(item));
      this.reprintOrders.push(item);
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    Undo: function() {
      console.log("Not Implented Yet");
      return;
    },

    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
  },
};
</script>
<style>
</style>
